import { h } from "preact";
import "./SortingMenuTop.scss";
import { useTranslations } from "global/config";

export const SortingMenuTop = () => {
    const translations = useTranslations();
    return <div className="sortingMenuTop k3e">{translations.SortTitle}</div>;
};
